import { configureStore } from '@reduxjs/toolkit';
import { UserApi } from '../API/UserApi';
import { QuestionApi } from '../API/QuestionApi';
import { StartQuizQApi } from '../API/StartQuizQApi';
const store = configureStore({
reducer:{
    // usersListStore: usersListReducer, no API
    // [usersListApi.reducerPath]: usersListApi.reducer, with api
  [UserApi.reducerPath]:UserApi.reducer,
  [QuestionApi.reducerPath]:QuestionApi.reducer,
  [StartQuizQApi.reducerPath]:StartQuizQApi.reducer,
},
middleware:(getDefaultMiddleware) => getDefaultMiddleware()
    .concat(UserApi.middleware)
    .concat(QuestionApi.middleware)
    .concat(StartQuizQApi.middleware)
});



export type RootState = ReturnType<typeof store.getState>;
export default store;